<template>
    <div v-once class="close-button bg-inverse cursor-pointer p-4">
        <span></span>
        <span></span>
    </div>
</template>

<script>
    export default {
        //
    }
</script>

<style lang="scss">
    @import "./../../sass/variables";

    .close-button{
        position: relative;
        z-index: $zindex-sticky;

        span{
            display: block;
            position: absolute;
            height: 8%;
            width: 40%;
            background: white;
            top: 50%;
            left: 50%;
            transition: .5s ease-in-out;

            &:nth-child(1) {
                transform: translate3d(-50%, -50%, 0) rotate3d(0, 0, 1, -45deg);
            }

            &:nth-child(2) {
                transform: translate3d(-50%, -50%, 0) rotate3d(0, 0, 1, 45deg);
            }
        }
        
        &:hover span{

            &:nth-child(1) {
                transform: translate3d(-50%, -50%, 0) rotate3d(0, 0, 1, 45deg);
            }

            &:nth-child(2) {
                transform: translate3d(-50%, -50%, 0) rotate3d(0, 0, 1, -45deg);
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/CloseButton.vue